import localSettings from '../../config/localSettings';

const URL_SETTINGS = '/settings.json';

let storedSettings = null;

/**
 * Store the settings and return it
 * @param {{ apiEndpoint: string, oidc_authority: string, oidc_client_id: string }} settings
 * @returns {{ apiEndpoint: string, oidc_authority: string, oidc_client_id: string }}
 */
export const storeSettingsAndReturn = (settings) => {
  storedSettings = settings;
  return settings;
};

/**
 * Get the settings which contains api endpoint and auth config
 * If settings is not present returns the local settings
 * @returns {Promise<{ apiEndpoint: string, oidc_authority: string, oidc_client_id: string }>}
 */
export const getSettings = () => {
  if (storedSettings) {
    return Promise.resolve(storedSettings);
  }

  return fetch(URL_SETTINGS)
    .then((response) => response.json())
    .then((settings) => storeSettingsAndReturn(settings))
    .catch(() => storeSettingsAndReturn(localSettings));
};

export default getSettings;